import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid2,
  IconButton,
  InputBase,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { submitFeedback } from "../../../api/FeedbackAPI";
import { useUser } from "../../../AuthContext";

const Feedback = ({ open, setOpen }) => {
  const [feedback, setFeedback] = useState("");
  const [error, setError] = useState("");
  const { accessToken } = useUser();

  const handleClose = () => {
    setOpen(false);
    setError("");
    setFeedback("");
  }

  const handleSubmit = async () => {
    if (!feedback.trim()) {
      setError("Feedback cannot be empty.");
      return;
    }
    setError(false);
  
    try {
      const data = await submitFeedback(feedback, accessToken);
      console.log("Feedback submitted successfully:", data);
      setFeedback("");
      setOpen(false);
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <Dialog onClose={handleClose} open={open} fullWidth>
      <DialogTitle sx={{ m: 0, p: 2 }}>Feedback</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{ position: "absolute", right: 8, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Grid2 size={{ xs: 12 }}>
          <InputBase
            id="feedback"
            autoFocus
            name="feedback"
            placeholder="Ideas on how to improve this product."
            multiline
            minRows={4}
            fullWidth
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            sx={{
              border: "1px solid #ccc",
              borderRadius: "4px",
              padding: "8px",
              fontFamily: "inherit",
            }}
          />
          {error !== "" && (
            <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
              {error}
            </span>
          )}
        </Grid2>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleSubmit}>
          Send Feedback
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Feedback;